const PageLayout = ({ children, className = "" }) => (
    <div className={`min-h-screen bg-gray-50 pt-12 pb-12 overflow-hidden ${className}`}>
        <div className="max-w-lg mx-auto px-2">
            {children}
        </div>
    </div>
);

export default PageLayout;
